import { i18n } from "@/i18n";
import moment from "moment";
import "moment/dist/locale/fr";

const momentInstance = moment;
momentInstance.locale(i18n.global.locale.value);

function copyToClipboard(string, trim) {
  let str = string;

  if (trim) {
    str = str.replace(/\s/g, "");
  }

  navigator.clipboard.writeText(str);
}

function getDate(date, format) {
  momentInstance.locale(i18n.global.locale.value);
  return momentInstance
    .utc(date, "YYYY/MM/DD HH:mm:ssZ")
    .local()
    .format(format);
}

function dateIsBefore(dateA, dateB) {
  momentInstance.locale(i18n.global.locale.value);
  return momentInstance(dateA, "YYYY/MM/DD HH:mm:ss").isBefore(
    momentInstance(dateB, "YYYY/MM/DD HH:mm:ss")
  );
}

function pluralize(condition) {
  return condition ? "s" : "";
}

function getWording(wording_key) {
  return i18n.global.t(wording_key);
}

export { copyToClipboard, getDate, dateIsBefore, pluralize, getWording };
